'use client';

import { useState, useEffect } from 'react';
import { Card } from '../ui/card';
import { Separator } from '../ui/separator';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import {
  AlertCircle,
  CheckCircle,
  Clock,
  FileText,
  XCircle
} from 'lucide-react';
import ActionButtons from './ActionButtons';

export function ApplicationSummary({ applicationId, selectedApplicationData }) {
  // This would typically fetch data based on the applicationId
  // For demo purposes, we'll use hardcoded data
  const summaryText =
    'Mi Hacienda LLC is a Mexican Restaurant with Alcohol, located at 509 Front Street, Coeburn, VA 24230. The expiring premiums include BOP $3066 and WC $1509. The submission includes Acord applications and loss runs.';
  const detailsText =
    'Mi Hacienda LLC is a Mexican restaurant with alcohol, operating at 509 Front Street, Coeburn, VA 24230. The business started operations on an unspecified date. The restaurant has a building area of 2,500 sq ft and annual revenues of $120,000. The expiring premiums for the business are $3066 for BOP and $1509 for WC. The loss history report indicates no losses were found based on the report selection criteria.';

  const [displayedSummary, setDisplayedSummary] = useState('');
  const [displayedDetails, setDisplayedDetails] = useState('');
  const [isTypingSummary, setIsTypingSummary] = useState(true);
  const [isTypingDetails, setIsTypingDetails] = useState(true);

  // Animation duration in milliseconds
  const animationDuration = 1500;

  // Calculate typing intervals based on text length and desired duration
  const summaryInterval = animationDuration / summaryText.length;
  const detailsInterval = animationDuration / detailsText.length;

  // Typing animation for summary
  useEffect(() => {
    if (!isTypingSummary) return;

    if (displayedSummary.length < summaryText.length) {
      const timeout = setTimeout(() => {
        setDisplayedSummary(summaryText.slice(0, displayedSummary.length + 1));
      }, summaryInterval);

      return () => clearTimeout(timeout);
    } else {
      setIsTypingSummary(false);
    }
  }, [displayedSummary, isTypingSummary, summaryText, summaryInterval]);

  // Typing animation for details
  useEffect(() => {
    if (!isTypingDetails) return;

    if (displayedDetails.length < detailsText.length) {
      const timeout = setTimeout(() => {
        setDisplayedDetails(detailsText.slice(0, displayedDetails.length + 1));
      }, detailsInterval);

      return () => clearTimeout(timeout);
    } else {
      setIsTypingDetails(false);
    }
  }, [displayedDetails, isTypingDetails, detailsText, detailsInterval]);

  return (
    <div className='space-y-6'>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        <Card className='p-4 border shadow-md'>
          <h3 className='text-base font-medium mb-3'>Summary</h3>
          <p className=' text-gray-700 mb-4 min-h-[80px]'>
            {selectedApplicationData &&
              selectedApplicationData?.application_short_summary}
            {isTypingSummary && (
              <span className='inline-block w-1 h-4 ml-0.5 bg-[#FF5533] animate-pulse'></span>
            )}
          </p>

          <div className='grid grid-cols-2 gap-4 '>
            <div>
              <p className='text-gray-500 mb-1'>Application Id:</p>
              <p className='font-mono'>{applicationId}</p>
            </div>
            <div>
              <p className='text-gray-500 mb-1'>Priority:</p>
              <p>{selectedApplicationData?.priority}</p>
            </div>
            <div>
              <p className='text-gray-500 mb-1'>LOBs:</p>
              <p>{selectedApplicationData?.lob || ''}</p>
            </div>
            <div>
              <p className='text-gray-500 mb-1'>Classification:</p>
              <p>{selectedApplicationData?.application_classification || ''}</p>
            </div>
          </div>
        </Card>

        <Card className='p-4 border shadow-md'>
          <h3 className='text-base font-medium mb-3'>Details</h3>
          <p className=' text-gray-700 mb-4 min-h-[80px]'>
            {selectedApplicationData?.application_detailed_summary || ''}
            {isTypingDetails && (
              <span className='inline-block w-1 h-4 ml-0.5 bg-[#FF5533] animate-pulse'></span>
            )}
          </p>
        </Card>
      </div>

      {/* <Separator />

      <div className='flex justify-between items-center'>
        <div className='flex items-center gap-2'>
          <Badge
            variant='outline'
            className='bg-yellow-50 text-yellow-700 border-yellow-200'
          >
            <Clock className='h-3 w-3 mr-1' />
            {selectedApplicationData?.application_status || 'Pending'}
          </Badge>
          <Badge
            variant='outline'
            className='bg-blue-50 text-blue-700 border-blue-200'
          >
            <FileText className='h-3 w-3 mr-1' />
            {selectedApplicationData?.application_type || 'New'}
          </Badge>
        </div>

        <div className='flex gap-2'>
          <ActionButtons />
        </div>
      </div> */}
    </div>
  );
}
